export const dialog = (dialog, data, state) => ({
  external: true,
  method: 'dialog',
  dialog,
  data,
  state
});
